import { TAlbum, TTrack } from "@store/actions/track";

import { ERoutes } from "./constants";

export const makePath = (route: ERoutes, id: string) => {
  return route.replace(":id", id);
};

export const makePathForAlbum = (route: ERoutes, id: string) => {
  return `${route}?albumsId=${id}`;
};

export const makePathForTrack = (route: ERoutes, id: string) => {
  return `${route}?tracksId=${id}`;
};

export const makePathUniversal = (route: ERoutes, album?: TAlbum, track?: TTrack) => {
  if (album) {
    return makePathForAlbum(route, album._id);
  }
  if (track) {
    return makePathForTrack(route, track._id);
  }
};
